module.exports = __webpack_public_path__ + "static/media/avatar-testimony-3.302eedab.png";